import React, { useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getIsBpFetching,
  getIsBpSuccess,
  verifyBrokerAgainstProspectQF,
} from "../store/qf";
import Loader3Orange from "./Loader3Orange";
import UnauthorizedAccess from "./UnauthorizedAccess";

const AuthFetchForQF = (props) => {
  const { prospectid } = props;

  const isBpFetching = useSelector(getIsBpFetching);
  const isBpSuccess = useSelector(getIsBpSuccess);
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(
      verifyBrokerAgainstProspectQF({
        prospectid: prospectid,
      })
    );
  }, [dispatch, prospectid]);

  return (
    <React.Fragment>
      {isBpFetching ? (
        <div>
          <Loader3Orange></Loader3Orange>
        </div>
      ) : isBpSuccess ? (
        props.children
      ) : (
        <UnauthorizedAccess></UnauthorizedAccess>
      )}
    </React.Fragment>
  );
};

export default AuthFetchForQF;
